import { render, staticRenderFns } from "./AccountSettingProfessional.vue?vue&type=template&id=1b01681c&"
import script from "./AccountSettingProfessional.vue?vue&type=script&lang=js&"
export * from "./AccountSettingProfessional.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingProfessional.vue?vue&type=style&index=0&id=1b01681c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports